import React from 'react'
import axios from 'axios'
import InputMask from 'react-input-mask' 

import Cidades from '../Cidades/Cidades.js'

import Cabecalho from '../Cabecalho/Cabecalho'
import Processo from '../Form/ProcessoNovo'
import Obs from '../Form/Obs'
import Button from '../Form/Button'

export default class NovoEstabelecimento extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            ficha: {
                cpfCnpj: '', estado: localStorage.estado, data: '', estabelecimento: '', fantasia: '', registro: '',
                endereco: '', municipio: '',
                uf: '', cep: '', telefone: '', fechadoObs: '',
                nome: localStorage.nome, matricula: localStorage.matricula
            },
            municipios: []
        }
    }

    save(e) {
        e.preventDefault()
        const url = '/api/paf/novoEstabelecimento'
        const ficha = this.state.ficha
        axios.post(url, ficha)
            .then(res => {
                alert('Estabelecimento registrado com sucesso!')
                // window.location = `/documentos/${res.data}`
            })
            .catch(error => {
                console.log(error.response)
                alert(error.response.data)
            })
    }

    updateField(event) {
        const ficha = { ...this.state.ficha }
        ficha[event.target.name] = event.target.value
        this.setState({ ficha })
        let cidades = Cidades[event.target.value]
        if (event.target.name == 'uf') {
            let uf = event.target.value
            const url = `ht://servicodados.ibge.gov.br/api/v1/localidades/estados/${uf}/municipios`
            axios.get(url, ficha)
                .then(resp => {
                    this.setState({ municipios: resp.data })
                })
                .catch(error => {
                    this.setState({ municipios: cidades })
                })
        }
    }

    renderTipo() {
        if (this.state.ficha.tipo == "CPF") {
            return (
                <React.Fragment>
                    <label className="col-2">CPF:</label>
                    <div className="col-4">
                        <InputMask type="text" className="form-control"
                            mask="999.999.999-99"
                            name="cpfCnpj"
                            onChange={e => this.updateField(e)} />
                    </div>
                </React.Fragment>
            )
        } else if (this.state.ficha.tipo == "CNPJ") {
            return (
                <React.Fragment>
                    <label className="col-2">CNPJ:</label>
                    <div className="col-4">
                        <InputMask type="text" className="form-control"
                            mask="99.999.999/9999-99"
                            name="cpfCnpj"
                            onChange={e => this.updateField(e)} />
                    </div>
                </React.Fragment>
            )
        } else {
            return <div></div>
        }
    }

    render() {
        return (
            <React.Fragment>
                <div className="container">
                    <Cabecalho />
                    <div className="form-group row mt-3 text-left">
                        <label className="col-4 col-md-2">Tipo:</label>
                        <div className="col-8 col-md-4 mb-3">
                            <select className="custom-select"
                                name="tipo"
                                onChange={e => this.updateField(e)} >
                                <option value=""></option>
                                <option value="CPF">Pessoa Física</option>
                                <option value="CNPJ">Pessoa Jurídica</option>
                            </select>
                        </div>
                        {this.renderTipo()}
                        <div className="col-12"></div>
                        <label className="col-3 col-md-2">Data:</label>
                        <div className="col-9 col-md-2 mb-3">
                            <input type="date" className="form-control"
                                name="data" onChange={e => this.updateField(e)} />
                        </div>
                        <label className="col-4 col-md-2">Estabelecimento:</label>
                        <div className="col-8 col-md-6 mb-3">
                            <input type="text" className="form-control"
                                name="estabelecimento" onChange={e => this.updateField(e)} />
                        </div>
                    </div>
                    <Button onClick={e => this.save(e)} />
                </div>
            </React.Fragment>
        )
    }

    renderMunicipios() {
        let select = []
        this.state.municipios.map(municipio => {
            select.push(<option value={municipio.nome}>{municipio.nome}</option>)
        })
        return select
    }
}